const CardRating = ({
  average = 0,
  count = 0,
}: {
  average?: number;
  count?: number;
}) => {
  if (!count) return null;
  return (
    <span className="cardRate">
      ★ {average.toFixed(1)} · {count}
    </span>
  );
};

export default CardRating;
